import { useEffect, useState } from 'react';
import { Table, Badge, Spinner, Alert } from 'react-bootstrap';
import { api } from '../api/client';
import { formatDateTime } from '../shared/dateFormat';

const STATUS_BADGE = { success: 'success', pending: 'warning', failed: 'danger', refunded: 'secondary' };

export default function AdminManagePayments() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  useEffect(() => {
    api.get('/admin/payments').then(setRows).catch((e) => setErr(e.message)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="text-center py-5"><Spinner /></div>;
  if (err) return <Alert variant="danger">{err}</Alert>;

  const total = rows.filter((r) => r.status === 'success').reduce((s, r) => s + Number(r.amount), 0);

  return (
    <>
      <h3 className="mb-3">Payments <small className="text-muted">(all incoming)</small></h3>
      <p className="mb-3">Total successful revenue: <strong>₹{total.toFixed(2)}</strong></p>
      <Table bordered hover responsive className="bg-white">
        <thead className="table-dark"><tr><th>#</th><th>User</th><th>Role</th><th>Purpose</th><th>Amount</th><th>Gateway</th><th>Txn</th><th>Status</th><th>When</th></tr></thead>
        <tbody>
          {rows.map((p) => (
            <tr key={p.id}>
              <td>{p.id}</td><td>{p.email}</td><td>{p.role}</td>
              <td>{p.purpose.replace('_', ' ')}</td>
              <td>₹{Number(p.amount).toFixed(0)}</td>
              <td>{p.gateway}</td>
              <td className="small text-muted">{p.txn_ref}</td>
              <td><Badge bg={STATUS_BADGE[p.status] || 'secondary'}>{p.status}</Badge></td>
              <td>{formatDateTime(p.created_at)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
}
